import { useMemo } from 'react';

import { useIsQuestionsAdminEnabled } from '../../featureChecks';
import type { UseMainUIFeatureSettings } from '../../types';
import { uiFeatureAccessSymbol } from '../../types';

export const useQuestionsAdminPageSettings: UseMainUIFeatureSettings<'questionsAdminPage'> = (options) => {
  const questionsAdminPageOverrides = options?.overrides?.questionsAdminPage;

  const isQuestionsAdminEnabled = useIsQuestionsAdminEnabled();

  return useMemo(
    () => ({
      [uiFeatureAccessSymbol]: isQuestionsAdminEnabled,
      ...questionsAdminPageOverrides,
    }),
    [questionsAdminPageOverrides, isQuestionsAdminEnabled]
  );
};
